import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { styled } from 'styled-components';
import { Timing, } from '@debbie/common/dist/economy/billing-appendix-setups/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import * as billingAppendixSetupsAPI from '@debbie/cortex/dist/api/billing-appendix-setups.js';
import { selectVoucherTypes } from '@debbie/cortex/dist/economy/selectors.js';
import { Button, Checkbox, Input } from '..//index.js';
import THEME from '../../theme.js';
import { Col, Row } from '../Grid/index.js';
import { PlusCircle, XCircle } from '../Icons/index.js';
import SelectDOM from '../Select.js';
import q from '@debbie/cortex/dist/query.js';
import { billingAppendixSetupsEntity } from '@debbie/cortex/dist/billing-appendix-setups/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import { selectRole } from '@debbie/cortex/dist/me/selectors.js';
const selectableVoucherTypeCategories = [
    VoucherCategory.FEE,
    VoucherCategory.DISBURSEMENT,
    VoucherCategory.OVERPAYMENT,
    VoucherCategory.VAT,
    VoucherCategory.PAYOUT,
    VoucherCategory.COLLECTIONCOMMISSION,
];
const BillingAppendixSetup = (props) => {
    const { onCreate, editable: _editable, billingAppendixSetup } = props;
    const lang = useSelector((s) => s.lang);
    const meRole = useSelector(selectRole);
    const economyVoucherTypes = useSelector(selectVoucherTypes);
    const economyVoucherTypesLoader = useSelector((s) => s.economyVoucherTypes);
    const initAppendices = () => {
        return (billingAppendixSetup?.appendices || [
            {
                handle: lang.billingAppendixSetups.billing,
                timing: { type: Timing.ASAP, details: {} },
                onlyVoucherTypeIds: (economyVoucherTypes || [])
                    .filter((voucherType) => selectableVoucherTypeCategories.includes(voucherType.category))
                    .map((voucherType) => voucherType.voucherTypeId),
                billingAppendixId: crypto.randomUUID(),
                includeVatInDepositShare: false,
                hideFromCreditor: false,
            },
        ]);
    };
    const [name, setName] = useState(billingAppendixSetup?.name || '');
    const [loading, setLoading] = useState(false);
    const [appendices, setAppendices] = useState([]);
    const updateSetup = (i, update) => setAppendices(appendices.map((f, index) => i === index
        ? {
            ...f,
            ...update,
        }
        : f));
    useEffect(() => {
        if (h.isNotLoaded(economyVoucherTypesLoader)) {
            c.economy.getVoucherTypes();
        }
    }, []);
    useEffect(() => {
        if (economyVoucherTypes) {
            setAppendices(initAppendices());
        }
    }, [props.billingAppendixSetup, economyVoucherTypes]);
    if (!economyVoucherTypes) {
        return null;
    }
    const editable = !!((_editable || !!onCreate) &&
        (!props.billingAppendixSetup || !props.billingAppendixSetup.public) &&
        meRole &&
        isAdmin(meRole));
    return (React.createElement("div", null,
        React.createElement(Input, { placeholder: lang.billingAppendixSetups.name, onChange: (e) => setName(e.target.value), value: name, readonly: !editable, onSubmit: billingAppendixSetup?.name !== name &&
                meRole &&
                isAdmin(meRole) &&
                !onCreate
                ? async () => {
                    setLoading(true);
                    try {
                        await billingAppendixSetupsAPI.patch(billingAppendixSetup?.billingAppendixSetupId, { name });
                        q.invalidate(keys.write.modify(billingAppendixSetupsEntity, billingAppendixSetup.billingAppendixSetupId));
                    }
                    catch (error) {
                        console.error(error);
                        alert('Error. Please try again.');
                    }
                    setLoading(false);
                }
                : undefined }),
        appendices.map((setup, i) => (React.createElement(SetupStyled, { key: i },
            editable && (React.createElement(XCircle, { style: {
                    position: 'absolute',
                    cursor: 'pointer',
                    top: '-7px',
                    left: '-7px',
                }, onClick: () => setAppendices(appendices.filter((_, index) => index !== i)) })),
            React.createElement(Row, null,
                React.createElement(Col, { width: "6" },
                    React.createElement(Input, { disabled: !editable, value: setup.handle, placeholder: lang.billingAppendixSetups.appendixHandle, onChange: (e) => updateSetup(i, { handle: e.target.value }) })),
                React.createElement(Col, { width: "6" },
                    React.createElement(SelectDOM, { disabled: !editable, value: setup.timing.type, onChange: (e) => updateSetup(i, {
                            timing: { type: e.target.value, details: {} },
                        }) }, Object.values(Timing).map((timing) => (React.createElement("option", { value: timing, key: timing }, lang.billingAppendixSetupTimings[timing]))))),
                React.createElement(Col, { width: "12" },
                    React.createElement(Checkbox
                    // TODO: Lang
                    , { 
                        // TODO: Lang
                        placeholder: "Skjul afregninger af denne bilagstype p\u00E5 kreditorweb", disabled: !editable, checked: setup.hideFromCreditor, onChange: (e) => updateSetup(i, {
                            hideFromCreditor: e.target.checked,
                        }) }),
                    React.createElement(Checkbox
                    // TODO: Lang
                    , { 
                        // TODO: Lang
                        placeholder: "Inkluder moms i honoraret i indbetalingstabeller", disabled: !editable, checked: setup.includeVatInDepositShare, onChange: (e) => updateSetup(i, {
                            includeVatInDepositShare: e.target.checked,
                        }) }),
                    React.createElement(Select, { isDisabled: !editable, value: (setup.onlyVoucherTypeIds || []).map((voucherTypeId) => {
                            const voucherType = economyVoucherTypes?.find((voucherType) => voucherType.voucherTypeId === voucherTypeId);
                            return {
                                label: (voucherType &&
                                    lang.pluralEconomyVoucherTypeLabels[voucherType.voucherTypeId]) ||
                                    (voucherType && voucherType.label) ||
                                    '',
                                value: (voucherType && voucherType.voucherTypeId) || '',
                            };
                        }), isMulti: true, placeholder: lang.economy.pipeFilterSelectVoucherTypes, classNamePrefix: "select", options: economyVoucherTypes
                            .filter((voucherType) => selectableVoucherTypeCategories.includes(voucherType.category))
                            .map((voucherType) => ({
                            label: lang.pluralEconomyVoucherTypeLabels[voucherType.voucherTypeId] || voucherType.label,
                            value: voucherType.voucherTypeId,
                        })), onChange: (val) => {
                            updateSetup(i, {
                                onlyVoucherTypeIds: val
                                    ? val.map((v) => v.value)
                                    : undefined,
                            });
                        } })))))),
        editable && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => {
                    setAppendices(
                    // @ts-ignore
                    appendices.concat({
                        handle: lang.billingAppendixSetups.billing,
                        timing: { type: Timing.ASAP, details: {} },
                        onlyVoucherTypeIds: [],
                        billingAppendixId: crypto.randomUUID(),
                        includeVatInDepositShare: false,
                        hideFromCreditor: false,
                    }));
                } },
                React.createElement(PlusCircle, { style: {
                        margin: '0.2em 0.2em -0.2em 0.2em',
                    } }),
                ' ',
                lang.billingAppendixSetups.addNewSetup),
            React.createElement("br", null))),
        JSON.stringify(billingAppendixSetup?.appendices || {}) !==
            JSON.stringify(appendices || {}) &&
            meRole &&
            isAdmin(meRole) &&
            _editable ? (React.createElement(Button, { block: true, loading: loading, onClick: async () => {
                setLoading(true);
                try {
                    if (!billingAppendixSetup?.billingAppendixSetupId) {
                        throw new Error('billingAppendixSetup.billingAppendixSetupId is required');
                    }
                    await billingAppendixSetupsAPI.patch(billingAppendixSetup?.billingAppendixSetupId, { appendices });
                    q.invalidate(keys.write.modify(billingAppendixSetupsEntity, billingAppendixSetup.billingAppendixSetupId));
                }
                catch (error) {
                    console.error(error);
                    alert('Error. Please try again.');
                }
                setLoading(false);
            } }, lang.inputs.save)) : null,
        onCreate && (React.createElement(Button, { block: true, size: "small", loading: loading, disabled: !(name && appendices.length), onClick: async () => {
                setLoading(true);
                try {
                    await billingAppendixSetupsAPI.create({
                        name,
                        appendices: appendices,
                    });
                    q.invalidate(keys.write.create(billingAppendixSetupsEntity));
                    props.onCreate && props.onCreate();
                }
                catch (error) {
                    console.error(error);
                    alert('Error. Please try again.');
                }
                setLoading(false);
            } }, lang.billingAppendixSetups.createNew))));
};
export default BillingAppendixSetup;
const SetupStyled = styled.div `
  padding: ${THEME.GRID_SPACING}px;
  margin-bottom: ${THEME.GRID_SPACING}px;
  border-radius: 3px;
  background-color: #e6e6e6;
  position: relative;
`;
//# sourceMappingURL=BillingAppendixSetup.js.map